module.exports = __webpack_public_path__ + "static/img/zhangjiajie.e28934a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/city/zhangjiajie.jpg
// module id = blcM
// module chunks = 1